/* @flow */
import React, { PropTypes } from 'react';
import Parser from 'html-react-parser';

class FaqItem extends React.Component {

  static propTypes = {
    id: PropTypes.number,
    isActive: PropTypes.bool,
    toggle: PropTypes.func,
    a: PropTypes.string,
    q: PropTypes.string,
    groupId: PropTypes.number,
    addRef: PropTypes.func
  };

  constructor (props) {
    super(props);

    this.handleRef = this.handleRef.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleRef (ref) {
    this.props.addRef(this.props, ref);
  }

  handleClick () {
    this.props.toggle(this.props.id);
  }

  render () {
    return (
      <dl className="acoordion" ref={this.handleRef}>
        <dt className={this.props.isActive ? 'open' : null} >
          <a onClick={this.handleClick}>
            {this.props.q}
          </a>
        </dt>
        <dd>{Parser(this.props.a)}</dd>
      </dl>
    );
  }
}

export default FaqItem;



/** WEBPACK FOOTER **
 ** ./src/views/faq/faq-item.js
 **/